"use strict";
// This file controls what scripts and functionality are included.


// # Basics
import "./nav-and-mobilemenu.js";
import "./shortcodes.js";


// # Extras
import "./popup.js";
